/**
 * Created by valera.siestov on 22.07.2015.
 */

if (!window.module) {
    window.module = {};
}

module.slider = (function () {
    "use strict";

    var list = [],
        touch = (document.ontouchstart !== undefined),
        clickEvent = touch ? 'click' : 'click',

        /**
         * This function make slider of list of products
         *
         * @class slider
         * @param object
         * @constructor
         */
        slider = function (params) {
            var object,
                controls = {
                    pages: []
                },
                core = {
                    /**
                     * Calc count of element in viewport
                     *
                     * @method widthItemCount
                     */
                    widthItemCount: function () {
                        var list = controls.list.querySelectorAll('.slider__list__item'),
                            i,
                            count = list.length,
                            viewPortWidth = object.clientWidth,
                            itemInViewPort = 0,
                            countInViewPort = 0;

                        controls.itemCount = count;
                        controls.viewportWidth = viewPortWidth;

                        for (i = 0; i < count; i++) {
                            itemInViewPort += list[i].clientWidth;
                            countInViewPort++;

                            if (itemInViewPort > viewPortWidth + 1/*FF bug*/) {
                                countInViewPort--;
                                break;
                            }

                        }

                        if (count) {
                            controls.elementWidth = list[0].clientWidth;
                        }

                        controls.countInViewPort = countInViewPort;
                        controls.list.setAttribute('data-count', count - controls.countInViewPort);
                        core.checkButtons();
                    },

                    /**
                     * Move list towards direction
                     *
                     * @method moveList
                     * @param direction
                     */
                    moveList: function (direction) {
                        var list = controls.list,
                            item = parseFloat(list.getAttribute('data-move')),
                            maxCount = parseFloat(list.getAttribute('data-count')),
                            offset = 0;

                        if (controls.lock) {
                            return;
                        }

                        if (params.circle) {
                            offset = 2;
                        }

                        if (direction === 'left') {

                            if (item - controls.countInViewPort >= offset) {
                                item -= controls.countInViewPort;
                            } else if (item > offset) {
                                item -= maxCount - (maxCount - item - offset);
                            } else {
                                list.style.transition = '';
                                core.checkButtons(maxCount - offset, maxCount);
                                list.setAttribute('data-move', item - 1);
                                controls.lock = true;
                                list.addEventListener('transitionend', function transitionEnd(event) {
                                    console.log(event);
                                    list.style.transition = 'none';
                                    list.setAttribute('data-move', maxCount - offset);
                                    list.removeEventListener('transitionend', transitionEnd);
                                    controls.lock = false;

                                }, false);
                                return;
                            }

                        } else {
                            if (item + controls.countInViewPort <= maxCount - offset) {
                                item += controls.countInViewPort;
                            } else if (item < maxCount - offset) {
                                item += maxCount - item;
                            } else {
                                item += 1;
                                list.style.transition = '';
                                core.checkButtons(offset, maxCount);
                                list.setAttribute('data-move', item);
                                controls.lock = true;

                                list.addEventListener('transitionend', function transitionEnd(event) {
                                    list.style.transition = 'none';
                                    list.setAttribute('data-move', offset);
                                    list.removeEventListener('transitionend', transitionEnd);
                                    controls.lock = false;

                                }, false);

                                return;
                            }
                        }

                        core.checkButtons(item, maxCount);

                        list.setAttribute('data-move', item);
                        list.style.cssText = '';
                    },

                    addPages: function (wrap, count, viewportCount) {
                        var pageCount = count / viewportCount,
                            i,
                            oldPageList = wrap.querySelectorAll('.page-item'),
                            pageListCount = oldPageList.length,
                            fragment = document.createDocumentFragment(),
                            temp,
                            start = 0;

                        if (params.circle) {
                            start = 2;
                        }

                        for (i = start; i < pageListCount - start; i++) {
                            oldPageList[i].parentNode.removeChild(oldPageList[i]);
                        }

                        controls.pages.length = 0;

                        for (i = start; i < pageCount - start; i++) {
                            temp = document.createElement('span');
                            temp.className = 'page-item';
                            temp.innerHTML = i + 1;
                            temp.setAttribute('data-id', i);
                            temp.addEventListener('click', handlers.pageClick, false);
                            fragment.appendChild(temp);

                            controls.pages.push(temp);
                        }

                        wrap.querySelector('.slider__pages').appendChild(fragment);
                    },

                    checkPages: function (item) {
                        var pages = controls.pages,
                            pagesCount = pages.length,
                            i,
                            currentPage;

                        if (item === undefined) {
                            item = parseInt(controls.list.getAttribute('data-move'), 10);
                        }

                        if (pagesCount) {

                            if (!item) {
                                currentPage = 0;
                            } else {
                                currentPage = Math.ceil(item / controls.countInViewPort);
                            }

                            for (i = 0; i < pagesCount; i++) {
                                pages[i].classList.remove('active');
                            }

                            for (i = 0; i < pagesCount; i++) {
                                if (parseInt(pages[i].getAttribute('data-id'), 10) === item) {
                                    pages[i].classList.add('active');
                                }
                            }

                            //if (pages[currentPage]) {
                            //    pages[currentPage].classList.add('active');
                            //}

                            if (pagesCount) {
                                pages[0].innerHTML = currentPage + 1;
                            }


                        }
                    },

                    checkButtons: function (item, maxCount) {


                        if (item === undefined) {
                            item = parseInt(controls.list.getAttribute('data-move'), 10);
                        }
                        
                        if (maxCount === undefined) {
                            maxCount = parseInt(controls.list.getAttribute('data-count'), 10);
                        }
                        
                        if (item !== 0) {
                            controls.buttons[0].classList.add('active');
                        } else {
                            controls.buttons[0].classList.remove('active');
                        }

                        if (item === maxCount) {
                            controls.buttons[1].classList.remove('active');
                        } else {
                            controls.buttons[1].classList.add('active');
                        }

                        core.checkPages(item);
                    },

                    translate: function (dist, speed) {

                        var slide = controls.list,
                            style = slide && slide.style;

                        if (!style) {
                            return;
                        }

                        style.webkitTransitionDuration =
                            style.MozTransitionDuration =
                                style.msTransitionDuration =
                                    style.OTransitionDuration =
                                        style.transitionDuration = speed + 'ms';

                        style.webkitTransform =
                            style.msTransform =
                                style.MozTransform =
                                    style.OTransform =
                                        style.transform = 'translate3d(' + dist + 'px, 0, 0)';

                    },

                    currentPosition: function () {
                        var list = controls.list,
                            current = list.getAttribute('data-move'),
                            countInViewport2 =
                                1 / controls.elementWidth * controls.viewportWidth;

                        return -(current / countInViewport2 * controls.viewportWidth);
                    },

                    createPages: function () {
                        if (controls.buttonWrap) {
                            core.addPages(controls.buttonWrap, controls.itemCount, controls.countInViewPort);
                            core.checkPages();
                        }
                    }
                },
                handlers = {
                    /**
                     * Click to left button
                     *
                     * @method leftButtonClick
                     */
                    leftButtonClick: function () {
                        core.moveList('left');
                    },

                    /**
                     * Click to right button
                     *
                     * @method rightButtonClick
                     */
                    rightButtonClick: function () {
                        core.moveList('right');
                    },

                    touchStart: function (event) {
                        var touches = event.touches[0];

                        // measure start values
                        controls.start = {

                            // get initial touch coords
                            x: touches.pageX,
                            y: touches.pageY,

                            // store time to determine touch duration
                            time: +new Date

                        };

                        // used for testing first move event
                        controls.isScrolling = undefined;

                        // reset delta and end measurements
                        controls.delta = {};
                    },

                    touchMove: function (event) {
                        // ensure swiping with one touch and not pinching

                        if (event.touches.length > 1 || event.scale && event.scale !== 1) {
                            return;
                        }

                        var touches = event.touches[0],
                            start = controls.start;

                        // measure change in x and y
                        controls.delta = {
                            x: touches.pageX - start.x,
                            y: touches.pageY - start.y
                        };

                        // determine if scrolling test has run - one time test
                        if (controls.isScrolling === undefined) {
                            controls.isScrolling =
                                !!(controls.isScrolling || Math.abs(controls.delta.x) < Math.abs(controls.delta.y));
                        }

                        // if user is not trying to scroll vertically
                        if (!controls.isScrolling) {
                            event.preventDefault();
                            core.translate(controls.delta.x + core.currentPosition(), 0);
                        }

                    },

                    touchEnd: function (event) {
                        // measure duration
                        var duration = +new Date - controls.start.time,
                            delta = controls.delta;

                        // determine if slide attempt triggers next/prev slide
                        var isValidSlide =
                            Number(duration) < 250               // if slide duration is less than 250ms
                            && Math.abs(delta.x) > 20            // and if slide amt is greater than 20px
                            || Math.abs(delta.x) > controls.viewportWidth / 2;      // or if slide amt is greater than half the width

                        // determine direction of swipe (true:right, false:left)
                        var direction = delta.x < 0;

                        // if not scrolling vertically
                        if (!controls.isScrolling) {

                            if (isValidSlide) {

                                if (direction) {
                                    core.moveList('right');
                                } else {
                                    core.moveList('left');
                                }

                            } else {
                                controls.list.style.cssText = '';
                            }
                        }
                    },

                    resize: function () {
                        clearTimeout(controls.timeout);
                        controls.timeout = setTimeout(function () {
                            core.widthItemCount();
                            core.createPages();
                        }, 300);
                    },

                    pageClick: function () {
                        var id = parseInt(this.getAttribute('data-id'), 10),
                            pages = controls.pages,
                            i,
                            pagesCount = pages.length;

                        for (i = 0; i < pagesCount; i++) {
                            pages[i].classList.remove('active');
                        }

                        controls.list.setAttribute('data-move', (id - 1) * controls.countInViewPort);
                        this.classList.add('active');
                    }
                };

            function setEventList() {
                var list = controls.list.parentNode;
                
                controls.buttons[0].addEventListener(clickEvent, handlers.leftButtonClick, false);
                controls.buttons[1].addEventListener(clickEvent, handlers.rightButtonClick, false);
                //window.addEventListener('resize', handlers.resize, false);

                if (touch) {
                    list.addEventListener('touchstart', handlers.touchStart, false);
                    list.addEventListener('touchmove', handlers.touchMove, false);
                    list.addEventListener('touchend', handlers.touchEnd, false);
                    list.addEventListener('touchcancel', handlers.touchEnd, false);
                }
            }

            function getControls() {
                object = params.list;
                controls.buttons = object.querySelectorAll('.slider__button');
                controls.list = object.querySelector('.slider__list');
                controls.buttonWrap = object.querySelector('.slider__button-wrap');

                core.widthItemCount();
                core.createPages();
            }

            function init() {
                getControls();
                setEventList();
            }

            init();

            this.updateViewport = function () {
                core.widthItemCount();
                core.createPages();
            };
        };

    function add(object) {
        list.push(new slider(object));
    }

    function updateViewport() {
        var count = list.length,
            i;

        for (i = 0; i < count; i++) {
            list[i].updateViewport();
        }
    }

    return {
        add: add,
        updateViewport: updateViewport
    };

}());

window.addEventListener('DOMContentLoaded', function () {
    "use strict";

    var list = document.querySelectorAll('.slider'),
        count = list.length,
        i,
        compressorSlider,
        tempList,
        tempFirst,
        tempLast;

    for (i = 0; i < count; i++) {
        //if (list[i].parentNode.classList.contains('compressors__slider-wrap')) {
        //    compressorSlider = list[i];
        //}
        compressorSlider = list[i];
        tempList = compressorSlider.querySelectorAll('.slider__list__item');
        console.log(tempList.length);

        if (tempList[tempList.length - 2]) {
            tempFirst = tempList[tempList.length - 2].cloneNode(true);
        } else {
            tempFirst = tempList[tempList.length - 1].cloneNode(true);
        }

        tempLast = tempList[tempList.length - 1].cloneNode(true);

        tempList[0].parentNode.insertBefore(tempLast, tempList[0]);
        tempList[0].parentNode.insertBefore(tempFirst, tempLast);

        if (tempList[1]) {
            tempFirst = tempList[1].cloneNode(true);
        } else {
            tempFirst = tempList[0].cloneNode(true);
        }

        tempLast = tempList[0].cloneNode(true);

        tempList[0].parentNode.insertBefore(tempFirst, tempList[tempList.length]);
        tempList[0].parentNode.insertBefore(tempLast, tempFirst);

    }

    //if (compressorSlider) {
    //
    //
    //    //compressorSlider.querySelector('ul').setAttribute('data-move', 2);
    //}

    for (i = 0; i < count; i++) {
        module.slider.add({
            list: list[i],
            circle: true
        });
    }


}, false);